/* eslint-disable prettier/prettier */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { Box, useMediaQuery } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
// import ExportButton from "../../../components/common/ExportButton/ExportButton";
// import Loader from "../../../components/common/Loader/Loader";
import { Helmet } from "react-helmet";
import Toast from "../../../components/common/Toast";
import {
  INITIATE_PENDING_TRANSFER_FRIEND_DATA,
  SET_PENDING_TRANSFER_TYPE,
  SET_SELECTED_PENDING_TRANSFER_FRIEND,
} from "../../../redux/actionTypes/dashboard";
import Friends from "../../../services/api/friend";
import { ROUTES } from "../../../utils/constants";
import TransferTable from "../../../components/common/new/AccordianTable/TransferTable";
// import { FRIEND_TRANSFER_REQ_COL } from "../../../contants/table/friendSearch";
import ToggleStructure from "../../../components/Header/ToggleStructure/ToggleStructure";
import style from "../FriendSearch/FriendSearch.styles";
import { DEFAULT_TRANFER_TYPE } from "../../../redux/reducers/dashboard";
import { Constants } from "../../../contants";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import { performOperation } from "../../member/MemberSearch/utils";
import { friendTransferLoading } from "../../../redux/selectors/friend";
import Loader from "../../../components/common/Loader/Loader";
import PaginationForMobile from "../../../components/common/new/Pagination/PaginationForMobile";

const styles = {
  container: {
    height: "100%",
  },

  divLoader: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "12px",
  },
};

function TransferFriend() {
  const TITLE = "Friend Transfer Request - BSG";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(null);
  const { data, paginationInfo } = useSelector(
    (store) => store.view_friends.pendingTransfer
  );
  const transferType = useSelector(
    (state) => state.dashboard.transferPendingType
  );

  const isLoading = useSelector(friendTransferLoading);

  const fetchTransferFriendList = async (
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    dispatch({
      type: INITIATE_PENDING_TRANSFER_FRIEND_DATA,
      payload: {
        type: transferType,
        pageNumber,
        pageSize,
      },
    });
  };

  const onPaginationClick = (pageNumber) => {
    const { pageSize } = paginationInfo;
    fetchTransferFriendList(pageNumber, pageSize);
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    fetchTransferFriendList(0, newPageSize);
  };

  const handleForward = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_FRIEND,
      payload: { ...payload, id: payload.friendId },
    });
    navigate(`/${ROUTES.FRIEND_PENDING_TRANSFER.path}/forward`);
  };

  const handleReject = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_FRIEND,
      payload: { ...payload, id: payload.friendId },
    });
    navigate(`/${ROUTES.FRIEND_PENDING_TRANSFER.path}/reject`);
  };

  const handleRemarks = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_FRIEND,
      payload: { ...payload, id: payload.transferId },
    });
    navigate(`/remarks/friend/${payload.transferId}`);
    // navigate(`/${ROUTES.FRIEND_PENDING_TRANSFER.path}/forward`);
  };

  const handleAccept = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_FRIEND,
      payload: { ...payload, id: payload.friendId },
    });
    navigate(`/${ROUTES.FRIEND_PENDING_TRANSFER.path}/accept`);
  };

  const handleCancel = async (selectedFriend) => {
    try {
      await Friends.cancelFriend({
        id: selectedFriend.transferId,
        friendId: selectedFriend.friendId,
      });
      setShowToast({
        message: "Cancel Successfully",
        severity: "success",
      });
      fetchTransferFriendList();
    } catch (error) {
      setShowToast({
        message: error.message,
        severity: "error",
      });
      Sentry.captureException(error);
    }
  };

  const onRadioChange = (evt) => {
    dispatch({
      type: SET_PENDING_TRANSFER_TYPE,
      payload: evt.target.value,
    });
  };

  useEffect(() => {
    fetchTransferFriendList();
  }, [transferType]);

  useEffect(() => {
    // Reset Pending Transfer type
    return () =>
      dispatch({
        type: SET_PENDING_TRANSFER_TYPE,
        payload: DEFAULT_TRANFER_TYPE,
      });
  }, []);
  const isMobile = useMediaQuery("(max-width:768px)");
  return (
    <div style={styles.container}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: "1rem",
        }}
      >
        <Box style={style.left}>
          <Box style={style.radioContainer}>
            <ToggleStructure
              value={transferType}
              label="Friends"
              handleChange={onRadioChange}
            />
          </Box>
        </Box>
        {/* <ExportButton
          data={data}
          columnHeadingList={FRIEND_TRANSFER_REQ_COL}
          fileName="friend_transfer_request"
        /> */}
      </Box>
      <TransferTable
        data={data || []}
        handleForward={handleForward}
        handleReject={handleReject}
        handleRemarks={handleRemarks}
        handleCancel={handleCancel}
        handleAccept={handleAccept}
        cameFromFriendTransfer
      />
      {data.length ? (
        <Box style={style.pagination}>
          {isMobile ? (
            <PaginationForMobile
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          ) : (
            <Pagination
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          )}
        </Box>
      ) : (
        !isLoading && (
          <Box style={style.emptyContainer}>
            <h1 style={style.noDataMsg}>No Results</h1>
          </Box>
        )
      )}
      {isLoading && <Loader />}
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </div>
  );
}

export default TransferFriend;
